import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-mini-listing-img',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mini-listing-img.component.html',
})
export class MiniListingImgComponent {
  @Input({ required: true }) imgSrc = '';
  @Input() imgAlt = '';
  @Input() imgWidth = '40px';
  @Input() imgHeight = '32px';
}
